/* Refonte V4 mobile — zone pdp (fiche produit).
   1. Tailles MoonBundle : le <select> de l'app est doublé de puces (le select reste la source de vérité :
      on y écrit la valeur puis on émet input/change, comme le fait déjà la synchro couleur du thème).
   2. Barre d'achat collante : teinte · taille (ou palier choisi) + ancien prix + état « ajouté ».
   3. Nuancier : la pastille choisie reste visible dans la rangée qui défile. */
(function () {
  'use strict';
  var root = document.querySelector('[data-rs-pdp]');
  if (!root) return;
  var T = window.v4PdpT || {};

  function isColorSelect(s) {
    return Array.prototype.some.call(s.options, function (o) { return /N[ºo°]\s*\d/.test(o.value); });
  }
  // « Standard 48×74cm » → ["Standard", "48×74 cm"] ; « Queen 1.5m » → ["Queen", "1.5m"] ; « M » → ["M", ""]
  function splitLabel(v) {
    var m = /^(.*?)\s+(\d[\d.,]*\s*(?:[×x]\s*\d[\d.,]*)?\s*c?m)$/i.exec((v || '').trim());
    return m ? [m[1], m[2].replace(/(\d)(cm|m)$/i, '$1 $2')] : [v, ''];
  }
  function shortSize(v) { return splitLabel(v)[0]; }
  // Vêtements (S·M·L…) : aucune taille n'est présélectionnée à l'écran tant que la cliente n'a pas touché une puce.
  // Taie, parure, bonnet… : la 1re dimension (Standard, Twin) est une valeur par défaut légitime → ajout direct.
  var APPAREL = /^(XXS|XS|S|M|L|XL|XXL|XXXL|2XL|3XL|S\/M|M\/L|L\/XL)$/i;
  function isApparel(values) {
    return values.length > 1 && values.every(function (v) { return APPAREL.test(shortSize(String(v)).trim()); });
  }
  var lastApparel = null; // taille de vêtement déjà choisie : reprise quand l'app redessine un palier

  /* ---------- 1. Puces de taille sur les selects MoonBundle ---------- */
  var chipSets = [];
  function syncChips(set) {
    set.wrap.classList.toggle('is-untouched', !set.touched);
    set.wrap.querySelectorAll('.v4-chip').forEach(function (b) {
      var on = set.touched && b.dataset.value === set.sel.value;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on || (!set.touched && b === set.wrap.firstElementChild) ? 0 : -1;
    });
  }
  function chipify() {
    // nettoyage : puces dont le select a été retiré par l'app (changement de palier)
    chipSets = chipSets.filter(function (set) {
      if (set.sel.isConnected) return true;
      set.wrap.remove();
      return false;
    });
    root.querySelectorAll('.moonbundle-option-selector select').forEach(function (sel) {
      if (sel.dataset.v4Done) {
        var known = chipSets.filter(function (s) { return s.sel === sel; })[0];
        if (known) syncChips(known);
        return;
      }
      var opts = Array.prototype.slice.call(sel.options);
      if (!opts.length) return;
      if (isColorSelect(sel)) {
        if (opts.length === 1) { sel.classList.add('v4-static-select'); sel.tabIndex = -1; sel.dataset.v4Done = '1'; }
        return;
      }
      if (opts.length > 8) return;
      sel.dataset.v4Done = '1';
      var nameEl = sel.parentElement && sel.parentElement.querySelector('.moonbundle-option-name');
      var wrap = document.createElement('div');
      var short = opts.every(function (o) { return o.text.trim().length <= 4; });
      wrap.className = 'v4-chips' + (short ? ' v4-chips--short' : '');
      wrap.dataset.n = opts.length;
      wrap.style.setProperty('--n', Math.min(opts.length, 5));
      wrap.setAttribute('role', 'radiogroup');
      if (nameEl) wrap.setAttribute('aria-label', nameEl.textContent.trim());
      opts.forEach(function (o) {
        var b = document.createElement('button');
        var parts = splitLabel(o.text);
        b.type = 'button';
        b.className = 'v4-chip';
        b.dataset.value = o.value;
        b.setAttribute('role', 'radio');
        if (o.disabled) { b.classList.add('is-unavailable'); b.disabled = true; }
        var main = document.createElement('span'); main.className = 'v4-chip__main'; main.textContent = parts[0]; b.appendChild(main);
        if (parts[1]) { var sub = document.createElement('span'); sub.className = 'v4-chip__sub'; sub.textContent = parts[1]; b.appendChild(sub); }
        b.addEventListener('click', function (e) {
          e.preventDefault();
          setValue(set, o.value);
          set.touched = true;
          if (set.apparel) lastApparel = o.value;
          syncChips(set);
          applyChoose();
          updateBar();
        });
        wrap.appendChild(b);
      });
      // flèches gauche/droite dans le groupe (radio)
      wrap.addEventListener('keydown', function (e) {
        if (!/^Arrow(Left|Right|Up|Down)$/.test(e.key)) return;
        var btns = Array.prototype.slice.call(wrap.querySelectorAll('.v4-chip:not(:disabled)'));
        var i = btns.indexOf(document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        var n = btns[(i + (/Left|Up/.test(e.key) ? -1 : 1) + btns.length) % btns.length];
        n.focus(); n.click();
      });
      sel.insertAdjacentElement('afterend', wrap);
      sel.classList.add('v4-sr-select');
      sel.tabIndex = -1;
      sel.setAttribute('aria-hidden', 'true');
      var apparel = isApparel(opts.map(function (o) { return o.text; }));
      var set = { sel: sel, wrap: wrap, apparel: apparel, touched: !apparel };
      chipSets.push(set);
      sel.addEventListener('change', function () { syncChips(set); });
      syncChips(set);
    });
  }
  // palier changé (×2, ×4…) : la taille de vêtement déjà choisie est reprise pour la 1re pièce seulement
  // (la 2e peut être offerte : sa taille reste un choix explicite)
  function carryOver() {
    var act = lastApparel && root.querySelector('.moonbundle-option-active');
    if (!act) return;
    var sets = chipSets.filter(function (s) { return s.apparel && act.contains(s.wrap) && visible(s.wrap); });
    if (!sets.length || sets.some(function (s) { return s.touched; })) return;
    var s = sets[0];
    if (!Array.prototype.some.call(s.sel.options, function (o) { return o.value === lastApparel; })) return;
    s.touched = true; setValue(s, lastApparel); syncChips(s);
  }
  function setValue(set, v) {
    var sel = set.sel;
    if (sel.value !== v) {
      sel.value = v;
      sel.dispatchEvent(new Event('input', { bubbles: true }));
    }
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ---------- 1c. Taille à choisir (vêtements) : bouton principal + barre disent « Choisir ma taille » ---------- */
  function visible(el) { return !!(el && el.offsetParent !== null); }
  // puces du thème (sans MoonBundle) : même règle
  var themeSizeTouched = false;
  function themeSizeGroup() {
    var g = root.querySelector('[data-rs-size]:not([hidden])');
    if (!g || !visible(g)) return null;
    var vals = Array.prototype.map.call(g.querySelectorAll('[data-option-value]'), function (b) { return b.dataset.optionValue; });
    return isApparel(vals) ? g : null;
  }
  function missingSize() {
    for (var i = 0; i < chipSets.length; i++) {
      var s = chipSets[i];
      if (s.apparel && !s.touched && s.sel.isConnected && visible(s.wrap)) return s.wrap;
    }
    var g = themeSizeGroup();
    if (g && !themeSizeTouched) return g;
    return null;
  }
  var atcBtn = root.querySelector('[data-add-to-cart-btn]');
  var atcLbl = atcBtn && atcBtn.querySelector('[data-btn-label]');
  var atcLabel = atcLbl ? atcLbl.textContent.trim() : '';
  function applyChoose() {
    var g = themeSizeGroup();
    if (g) g.classList.toggle('is-untouched', !themeSizeTouched);
    var miss = !!missingSize();
    if (atcBtn && atcLbl && !atcBtn.disabled) {
      atcBtn.classList.toggle('v4-needs-size', miss);
      var cur = atcLbl.textContent.trim();
      if (miss && cur !== T.choose && cur !== '...' && cur !== '✓') { atcLabel = cur; atcLbl.textContent = T.choose; }
      else if (!miss && cur === T.choose) atcLbl.textContent = atcLabel;
    }
    if (barBtn && !barBtn.disabled && !bar.classList.contains('is-added')) {
      var want = miss ? T.choose : (T.add || barBtn.textContent.trim());
      if (barBtn.textContent.trim() !== want) barBtn.textContent = want;
      bar.classList.toggle('v4-needs-size', miss);
    }
  }
  function flash(el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    el.classList.remove('rs-flash'); void el.offsetWidth; el.classList.add('rs-flash');
    // pas de focus déplacé : un anneau sur « S » ferait croire que S est choisie
  }
  // avant tout autre écouteur (MoonBundle, emballage cadeau, ajout AJAX) : pas d'ajout sans taille de vêtement
  function guard(e) {
    var b = e.target.closest && e.target.closest('[data-add-to-cart-btn], [data-mobile-atc]');
    if (e.type === 'submit') b = e.target.matches && e.target.matches('[data-product-form], form[action*="/cart/add"]') && root.contains(e.target) ? e.target : null;
    if (!b) return;
    var miss = missingSize();
    if (!miss) return;
    e.preventDefault(); e.stopImmediatePropagation();
    flash(miss);
  }
  window.addEventListener('click', guard, true);
  window.addEventListener('submit', guard, true);
  root.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-rs-size] [data-option-index]')) { themeSizeTouched = true; setTimeout(function () { applyChoose(); updateBar(); }, 0); }
  });

  /* ---------- 1b. Teinte choisie sur la fiche → pastilles MoonBundle ----------
     L'app affiche désormais la couleur en pastilles (radiogroup) et non plus en <select> : la synchro du thème
     (layout, selects uniquement) ne l'atteignait plus → la taie partait en Nº 01 quelle que soit la teinte choisie.
     On clique la pastille de l'app correspondante, sauf si le client l'a lui-même changée. */
  function currentColor() {
    var s = root.querySelector('.v4-sw.is-selected');
    return s ? s.dataset.optionValue : null;
  }
  function colorNum(v) { var m = /N[ºo°]\s*0*(\d+)/i.exec(v || ''); return m ? m[1] : null; }
  function syncMoonColor() {
    var num = colorNum(currentColor());
    if (!num) return;
    root.querySelectorAll('.moonbundle-swatch-buttons').forEach(function (g) {
      if (!/colou?r|couleur|farbe|colore/i.test(g.dataset.name || g.getAttribute('aria-label') || '')) return;
      if (g.dataset.v4User === '1') return;
      var btns = Array.prototype.slice.call(g.querySelectorAll('[data-value]'));
      var target = btns.filter(function (b) { return colorNum(b.dataset.value) === num; })[0];
      if (!target || target.getAttribute('aria-checked') === 'true') return;
      target.click();
    });
  }
  // un vrai clic du client sur une pastille de l'app : on ne la touche plus
  root.addEventListener('click', function (e) {
    var g = e.isTrusted && e.target.closest && e.target.closest('.moonbundle-swatch-buttons');
    if (g) g.dataset.v4User = '1';
  }, true);

  /* ---------- 2. Barre d'achat collante ---------- */
  var bar = document.getElementById('mobile-atc-bar');
  var barVar = bar && bar.querySelector('[data-v4-bar-variant]');
  var barWas = bar && bar.querySelector('[data-v4-bar-was]');
  var cmpOn = barWas && barWas.dataset.on === '1';
  var barBtn = bar && bar.querySelector('[data-mobile-atc]');
  var variantCmp = null, variantPrice = null;
  var initWas = barWas && !barWas.hidden ? barWas.textContent.trim() : '';
  var money = function (c) { return window.rsMoney ? window.rsMoney(c) : (c / 100).toFixed(2); };

  function moonBox() { return root.querySelector('.moonbundle-box'); }
  function updateBar() {
    if (!bar) return;
    var box = moonBox(), label = '', was = '', tierChosen = false;
    if (box) {
      var opts = Array.prototype.slice.call(box.querySelectorAll('.moonbundle-option'));
      var act = box.querySelector('.moonbundle-option-active');
      var i = opts.indexOf(act);
      if (act && i > 0) {
        // quantité du palier (« x2 » → « ×2 ») : court et lisible dans la barre ; sinon le titre du palier
        var q = act.querySelector('.moonbundle-option-quantity'), t = act.querySelector('.moonbundle-option-title');
        label = q && /\d/.test(q.textContent) ? q.textContent.trim().replace(/^x\s*/i, '×') : (t ? t.textContent.replace(/\s+/g, ' ').trim() : '');
        tierChosen = true;
      } else if (act && opts.length > 1) {
        var s = Array.prototype.filter.call(act.querySelectorAll('select'), function (x) { return !isColorSelect(x); })[0];
        if (s) label = shortSize(s.value);
      }
      var old = act && act.querySelector('.moonbundle-option-old-price');
      was = old ? old.textContent.replace(/​/g, '').trim() : '';
    } else {
      var d = root.querySelector('[data-rs-size]:not([hidden]) [data-option-display]');
      if (d) label = shortSize(d.textContent);
      if (variantPrice == null) was = initWas;
      else if (variantCmp && variantCmp > variantPrice) was = money(variantCmp);
    }
    // vêtement sans taille choisie : pas de taille « par défaut » dans la barre
    // (le libellé d'un palier « ×2 / ×4 » reste affiché : c'est un choix explicite)
    if (!tierChosen && missingSize()) label = '';
    if (barVar && barVar.textContent !== label) barVar.textContent = label;
    // « Nº 01 Perle de Lait · Standard » ne tient pas sur 390 px : avec une taille/un palier, la teinte se résume à « Nº 01 »
    // (la vignette montre déjà la couleur) ; sans, le nom complet
    var bn = bar.querySelector('[data-rs-bar-name]'), full = root.querySelectorAll('.v4-sw').length > 1 ? currentColor() : null;
    if (bn && full) {
      var m = /^N[º°o]\s*\d+/.exec(full);
      var want = label && m ? m[0] : full;
      if (bn.textContent !== want) bn.textContent = want;
    }
    if (barWas) {
      var show = cmpOn && !!was;
      if (show && barWas.textContent !== was) barWas.textContent = was;
      barWas.hidden = !show;
    }
  }
  document.addEventListener('pdp:variant-changed', function (e) {
    var v = e.detail && e.detail.variant;
    if (v) { variantCmp = v.compare_at_price; variantPrice = v.price; }
    updateBar();
    setTimeout(function () { keepSwatchInView(true); }, 0); // après la mise à jour des classes par le thème
  });

  // État « ajouté » : retour visuel sur la barre (le bouton principal a déjà le sien)
  var addedTimer;
  document.addEventListener('cart:updated', function () {
    if (!bar || !barBtn || !T.added) return;
    var prev = barBtn.dataset.v4Label || barBtn.textContent.trim();
    barBtn.dataset.v4Label = prev;
    bar.classList.add('is-added');
    barBtn.textContent = '✓ ' + T.added;
    clearTimeout(addedTimer);
    addedTimer = setTimeout(function () {
      bar.classList.remove('is-added');
      barBtn.textContent = barBtn.dataset.v4Label;
      delete barBtn.dataset.v4Label;
    }, 1800);
  });

  // flèches gauche/droite dans le nuancier et les puces du thème (groupes radio)
  root.addEventListener('keydown', function (e) {
    if (!/^Arrow(Left|Right)$/.test(e.key)) return;
    var g = e.target.closest && e.target.closest('.v4-colors__rail, [data-rs-size] .v4-chips');
    if (!g) return;
    var btns = Array.prototype.slice.call(g.querySelectorAll('[data-option-index]'));
    var i = btns.indexOf(e.target);
    if (i < 0) return;
    e.preventDefault();
    var n = btns[(i + (e.key === 'ArrowLeft' ? -1 : 1) + btns.length) % btns.length];
    n.focus(); n.click();
  });

  /* ---------- 3. Nuancier : pastille choisie visible ---------- */
  function keepSwatchInView(smooth) {
    var rail = root.querySelector('.v4-colors__rail');
    var sw = rail && rail.querySelector('.v4-sw.is-selected');
    if (!rail || !sw || rail.scrollWidth <= rail.clientWidth) return;
    var l = sw.offsetLeft - rail.offsetLeft, r = l + sw.offsetWidth;
    if (l >= rail.scrollLeft + 16 && r <= rail.scrollLeft + rail.clientWidth - 32) return;
    rail.scrollTo({ left: Math.max(0, l - rail.clientWidth / 2 + sw.offsetWidth / 2), behavior: smooth ? 'smooth' : 'auto' });
  }

  /* ---------- Démarrage + suivi des rendus de l'app ---------- */
  document.addEventListener('click', function () { refresh(); }, true);
  document.addEventListener('change', function () { refresh(); }, true);
  var t;
  // l'app gère la taille dans ses paliers : le sélecteur du thème disparaît, même si l'app arrive tard (> 7,5 s)
  function hideThemeSize() {
    if (!moonBox()) return;
    root.querySelectorAll('[data-rs-size]:not([hidden])').forEach(function (el) { el.hidden = true; });
  }
  function refresh() { clearTimeout(t); t = setTimeout(function () { hideThemeSize(); chipify(); carryOver(); syncMoonColor(); applyChoose(); updateBar(); }, 60); }
  hideThemeSize(); chipify(); syncMoonColor(); applyChoose(); updateBar(); keepSwatchInView(false);
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var n = muts[i].target;
      if (n.closest && n.closest('.v4-chips')) continue; // nos propres changements
      refresh(); return;
    }
  }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();
